import Vue from 'vue'
import App from './App.vue'
import './assets/plugins/font-awesome/font-awesome.min.css'
import VuejsClipper from 'vuejs-clipper'
import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'
import store from './store'
import router from './router'
import 'swiper/css/swiper.min.css'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-116383309-5',
  router: router,
  autoTracking: {
    exception: true,
    transformQueryString: false
  }
})

Vue.config.productionTip = false
// install
Vue.use(Buefy)
Vue.use(VuejsClipper)


Vue.mixin({
  methods: {
    $t(key) {
      return this.$store.getters.getTranslation(key)
    },
    $tif(en, ar) {
      if (this.$store.state.language === 'en') return en
      else return ar
    }
  }
})

new Vue({
  router: router,
  store: store,
  render: h => h(App),
}).$mount('#app')
